/* Make parent menu items clickable on desktop in Dawn 15+ while keeping the caret dropdown */
document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll('.header__inline-menu li');

  menuItems.forEach((item) => {
    const details = item.querySelector('details');
    const summary = item.querySelector('summary');

    // Only apply to items that have dropdowns
    if (!details || !summary) return;

    // Identify the actual link for the parent category
    const parentLink =
      item.querySelector(':scope > a[href]') ||
      details.querySelector(':scope > a[href]') ||
      details.querySelector('a[href]');

    if (!parentLink) return;

    summary.addEventListener('click', function (e) {
      const clickedCaret = e.target.closest('.icon-caret, svg, path, use');

      // If clicking caret → toggle dropdown (default behavior)
      if (clickedCaret) return;

      // If clicking text on desktop → go to collection
      if (window.matchMedia('(min-width: 990px)').matches) {
        e.preventDefault();
        window.location.href = parentLink.getAttribute('href');
      }
    });
  });
});
